var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-card',{staticClass:"my-16",attrs:{"title":_vm.$t('contactUs')}},[(_vm.skeleton)?_c('v-skeleton-loader',{staticClass:"pa-2",attrs:{"type":"article@2,text"}}):_c('ContactUsData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }